import { breakpoints, Column, Columns, PageBlock, Skeleton, Stack, vars } from '@etg/wings';
import { css, cx } from '@eti/styles';
import LoadingBar from '../loading-bar/LoadingBar';
import SortingSkeleton from './SortingSkeleton';
import FlightResultSkeleton from './FlightResultSkeleton';

export const NUMBER_OF_RESULTS = 5;

const blockStyles = css`
  background-color: ${vars.colors.page.background.primary};
`;

const filtersStyles = css`
  display: none;

  @media (min-width: ${breakpoints._970}) {
    display: block;
  }
`;

const filterSkeletonHeight = css`
  height: 1.5rem;
`;

const filterControlSkeleton = css`
  width: 65%;
`;

const ResultSkeleton = () => {
  return (
    <>
      <LoadingBar />
      <PageBlock className={blockStyles} data-testid="resultPage-skeleton" withPaddingY>
        <Columns>
          <Column className={filtersStyles} width="1/4">
            <Stack spacing={40}>
              {[...Array(6)].map((_, index) => (
                <Stack key={index}>
                  <Skeleton className={filterSkeletonHeight} />
                  <Skeleton className={cx(filterSkeletonHeight, filterControlSkeleton)} />
                </Stack>
              ))}
            </Stack>
          </Column>
          <Column width={{ [breakpoints._0]: '4/4', [breakpoints._970]: '3/4' }}>
            <SortingSkeleton />
            <Stack>
              {[...Array(NUMBER_OF_RESULTS)].map((_, index) => (
                <FlightResultSkeleton key={index} />
              ))}
            </Stack>
          </Column>
        </Columns>
      </PageBlock>
    </>
  );
};

export default ResultSkeleton;
